import Table from '../../../../../../common/components/table';


export const ChaptersComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedForumGroupsValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedForumGroupsValues}
                headingName="Chapters Details"
            />
        </div>
    )
}
export default ChaptersComponent;
